import { v4 as uuidv4 } from "uuid";
import { faker } from "@faker-js/faker";
import { isArrayWithLength } from "../../utils/array-methods";
import { getStorage, setStorage } from "../helpers/storage";
import stagingConfig from "./launch-configurations/staging-configuration.json";

const createConfig = (data) => {
  const config = {
    Id: uuidv4(),
    Name: data.Name || "Default",
    Description: data.Description,
    Accounts: data.Accounts,
    IsEnabled: data.IsEnabled || faker.random.boolean(),
    IsCustomizable: data.IsCustomizable,
    Parameters: data.Parameters || [],
    IsDefault: data.IsDefault,
  };
  return config;
};

export const getLaunchConfigurations = async () => {
  const items = [
    {
      Name: "Default",
      Description: "Default configuration for all accounts",
      Cost: 49,
      IsDefault: true,
      IsEnabled: true,
      Accounts: [
        {
          AccountNumber: "932383143047",
          Regions: ["us-east-1"],
          IsPermissionConfigured: true,
        },
      ],
    },
    {
      Name: "Development",
      Description: "Development configuration for Acme Corp. Master",
      Cost: 54,
      IsCustomizable: true,
      Accounts: [
        {
          AccountNumber: "932383143047",
          Regions: ["us-east-1"],
          IsPermissionConfigured: true,
        },
      ],
    },
    stagingConfig,
    {
      Name: "Production",
      Description: "Production configuration for Acme Corp. Master",
      Cost: 70,
      IsCustomizable: true,
      Accounts: [
        {
          AccountNumber: "932383143047",
          Regions: ["us-east-1"],
          IsPermissionConfigured: true,
        },
      ],
    },
  ];

  const updatedData = [];

  for (const item of items) {
    const data = await createConfig(item);
    updatedData.push(data);
  }
  return updatedData;
};

export const createLaunchConfiguration = async (data) => {
  const updatedData = {
    ...data,
    Accounts: data.Accounts.map((account) => {
      return {
        ...account,
        IsPermissionConfigured: true,
      };
    }),
  };
  const configuration = createConfig(updatedData);
  let configurations = await getStorage("LAUNCH_CONFIGURATIONS");
  if (isArrayWithLength(configurations)) {
    configurations.push(configuration);
  } else {
    configurations = [];
    configurations.push(configuration);
  }
  await setStorage("LAUNCH_CONFIGURATIONS", configurations);
};
